const e=async(e,t,n)=>{let{data:r}=await e.post(`/apps/${t}/system-roles`,n);return r};export{e as createSystemRole};
//# sourceMappingURL=create-system-role.mjs.map